const stats = [
  { value: "100+", label: "Projects", bg: "/stats-1.jpg", color: "bg-orange-500" },
  { value: "PAN-India", label: "Operational Presence", bg: "/stats-2.png", color: "bg-gray-800" },
  { value: "5000+", label: "Man-Hours", bg: "/stats-3.jpg", color: "bg-orange-500" },
];

export default function Stats() {
  return (
    <section className="bg-gray-50 py-14 sm:py-16 lg:py-20 2xl:py-24">
      <div className="max-w-6xl 2xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Responsive Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 2xl:gap-10">
          
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="
                relative overflow-hidden rounded-xl shadow-md bg-white
                p-6 sm:p-8 lg:p-10
                min-h-[180px] sm:min-h-[200px] lg:min-h-[210px] 2xl:min-h-[240px]
                flex flex-col justify-center
              "
            >
              {/* Background Image */}
              <img
                src={stat.bg}
                alt={stat.label}
                className="absolute inset-0 w-full h-full object-cover opacity-20"
              />

              {/* White Overlay */}
              <div className="absolute inset-0 bg-white/[0.20]"></div>

              {/* Content */}
              <div className="relative z-10 text-left">
                
                <h2
                  className={`
                    font-bold
                    text-3xl sm:text-4xl lg:text-4xl 2xl:text-5xl
                    ${stat.value === "PAN-India"
                      ? "text-orange-500"
                      : "text-gray-900"}
                  `}
                >
                  {stat.value}
                </h2>

                <p className="text-gray-500 mt-2 uppercase tracking-wide text-xs sm:text-sm">
                  {stat.label}
                </p>

                {/* Accent Line */}
                <div className={`w-8 sm:w-10 h-[3px] mt-3 sm:mt-4 ${stat.color}`}></div>
              </div>

            </div>
          ))}

        </div>
      </div>
    </section>
  );
}
